import { Box, IconButton, Tooltip } from '@mui/material';
import { grey } from 'assets/colors/colors';
import { UnVerifiedIcon } from 'pages/ProjectBudget/DayworkDocket/common/SvgIcons';
import CustomChipForWetandDryHire from 'pages/Timesheet/Form/Equipment/CustomChipForDryandWetHire';

type IVerifiedStatus = 'Verified' | 'UnVerified';

export interface IArg {
  verified_status: IVerifiedStatus;
  isDisabled?: boolean;
  equipment_name: string;
  equipment_id: string;
  wet_hire: boolean;
  dry_and_wet_hire: boolean;
}

export const renderEquipmentCustomLabel = (
  arg: IArg,
  changeHireTypePermission: boolean,
) => (
  <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
    {arg?.verified_status === 'UnVerified' && (
      <Tooltip title="Unverified" placement="top">
        <IconButton aria-label="Unverified">
          <UnVerifiedIcon />
        </IconButton>
      </Tooltip>
    )}
    <Box
      sx={{
        color: arg?.isDisabled ? grey.g600 : 'inherit',
        width: '100%',
      }}
    >
      {`${arg.equipment_name} (${arg.equipment_id})`}
    </Box>
    <div>
      <CustomChipForWetandDryHire
        equipmentData={arg}
        changeHireTypePermission={changeHireTypePermission}
      />
    </div>
  </Box>
);
